import { useUpdateEntityApi } from '@/common/api/updateEntityApi';
import type { Package } from 'shared/packages/domain/package';
import type { PackageContent } from 'shared/packages/domain/packageContent';
import type { PackageStatus } from 'shared/packages/domain/packageStatus';
import { usePackageStore } from 'shared/packages/stores/packageStore';

export interface UpdatePackage {
  number: string | null;
  externalNumber: string | null;
  status: PackageStatus;
  statusValidFrom: string | null;
  statusValidTo: string | null;
  packageTypeId: string | null;
  piecesCount?: number | null;
  layers?: number | null;
  piecesPerLayer?: number | null;
  spacerHeight?: number | null;
  packageStorageAreaId?: string | null;
  stackLevel?: number | null;
  occupiedStoragePlaceIds?: string[];
  nominalWeight?: number | null;
  weight?: number | null;
  nominalHeight?: number | null;
  height?: number | null;
  nominalWidth?: number | null;
  width?: number | null;
  nominalLength?: number | null;
  length?: number | null;
  longitude?: number | null;
  latitude?: number | null;
  rotation?: number | null;
  comment: string | null;
  contents: PackageContent[];
}

export interface UpdatePackageResponse {
  ok: true;
  package: Package;
}

export function useUpdatePackage() {
  const store = usePackageStore();

  return useUpdateEntityApi<UpdatePackage, UpdatePackageResponse>({
    url: 'package',
    translate: (t) => t.packages.actions.update,
    async processOk(response) {
      const json = await response.json() as Package;
      store.add(json);
      return {
        ok: true,
        package: json,
      };
    },
  });
}
